const COUNTRY_CODES = [
  '+962', '+971', '+966', '+965', '+973', '+974', '+968', '+20', '+961', '+964', '+92'
];

export const splitPhoneNumber = (fullNumber?: string) => {
  if (!fullNumber) return { countryCode: '', phone: '' };
  const code = COUNTRY_CODES.sort((a, b) => b.length - a.length)
    .find(code => fullNumber.startsWith(code));
  if (code) {
    return {
      countryCode: code,
      phone: fullNumber.slice(code.length)
    };
  }
  return { countryCode: '', phone: fullNumber };
}